import ServicesListings from "../../../Components/Pricings/Services/ServicesListings";

export default function ServiceListing() {
    return (
        <ServicesListings />
    )
}